/* Tries to find fields with errors, if any are found scrolls the first one into view
 *
 * Has to be explicitly called in page template, like this:
 *
 * {% block scripts %}
 *   {{ block.super }}
 *   <script>
 *     trafo.scrollErrorsIntoView();
 *   </script>
 * {% endblock scripts %}
 * */
import scrollIntoView from 'scroll-into-view-if-needed';
import smoothScrollIntoView from 'smooth-scroll-into-view-if-needed';

const scrollElementIntoView = (element, force) => {
    // Use native implementation of smooth scrolling if possible
    const scrollIntoViewSmoothly =
        'scrollBehavior' in document.documentElement.style ? scrollIntoView : smoothScrollIntoView;

    // Avoid scrolling if scrolled already
    if (window.scrollY !== 0 && !force) {
        return;
    }

    // Try scrolling into view
    if (element) {
        // Do with delay, for better UX and to let React components to render
        setTimeout(
            () => {
                scrollIntoViewSmoothly(element, { block: 'start', scrollMode: 'if-needed', behavior: 'smooth' });
            },
            force ? 0 : 1000,
        );
    }
};

export const scrollElementIntoViewById = (id, force) => {
    const element = document.getElementById(id);

    scrollElementIntoView(element, force);
};

export const scrollErrorsIntoView = (force) => {
    // Avoid scrolling if scrolled already
    if (window.scrollY !== 0 && !force) {
        return;
    }

    // Search for error labels
    const errorLabels = document.getElementsByClassName('invalid-feedback');
    if (!errorLabels.length) {
        return;
    }

    // Try scrolling into view
    const formFieldLabel = errorLabels[0].parentElement.parentElement;

    scrollElementIntoView(formFieldLabel, force);
};

export default scrollElementIntoView;



// WEBPACK FOOTER //
// ./src/utils/scrollElemntIntoView.js